import { DealerSliceState } from "./types";

export const initialState: DealerSliceState = {
  dealersList: [],
  dealersListForFilter: [],
  branchesList: [],
  currentDealer: null,
  currentDealerBranch: null,
  currentDealerUsers: [],
  currentDealerUsersForFilter: [],
  currentDealerBranchesForFilter: [],
  hideBranchesColumnsList: [],
  excludeItems: [
    "isMain",
    "status",
    "inn",
    "kpp",
    "deliveryAddress",
    "shortName",
  ],
  currentMainDealer: null,
  branchesSort: null,
  isLoading: false,
  isMiniLoading: false,
  error: null,
  filials: [],
  filialsSortRule: null,
  mainFilial: null,
  selectedFilials: [],
  hasUpdates: false,
  onlyExporters: false,
  onlySelfWorkers: false,
  onlyMyDealers: false,
  searchQuery: "",
  cities: [],
  dealerRemainsReports: [],
  dealerRemainsLastManualReport: null,
  dealerSalesReports: [],
  dealerSalesLastManualReport: null,
  orderedDealers: [],
  selectedDealerIds: [],
  isDatePickerActive: false,
  dealerSort: { field: null, type: "asc" },
  isHandcraftOrderLoading: false,
};
